document.addEventListener('DOMContentLoaded', function () {
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const activeTab = (targetTab, targetContent, tabs, contents) => {
    tabs.forEach(el => el.classList.remove('active'));
    contents.forEach(el => el.classList.remove('active'));
    if (targetTab) targetTab.classList.add('active');
    if (targetContent) targetContent.classList.add('active');
  };

  // ★ 初期アクティブを保証（既にactiveがあるなら何もしない）
  const setInitialActive = (tabs, contents) => {
    const hasActive =
      tabs.some(el => el.classList.contains('active')) ||
      contents.some(el => el.classList.contains('active'));
    if (!hasActive) {
      if (tabs[0]) tabs[0].classList.add('active');
      if (contents[0]) contents[0].classList.add('active');
    }
  };

  // --- 上位タブ ---
  const topTabs = $$('.tab-switching__link');
  const topContents = $$('.tab-switching__content');

  topTabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const id = tab.dataset.tab;
      const target = id ? document.getElementById(id) : null;
      activeTab(tab, target, topTabs, topContents);
    });
  });

  // 初期アクティブ（1個目）※上位
  setInitialActive(topTabs, topContents);

  // --- 各コンテンツ内のサブタブ ---
  topContents.forEach(container => {
    const blockId = container.getAttribute('data-block-id');
    if (!blockId) return;

    // 必要に応じてdocument全体から拾う or container内に限定
    const innerTabs   = $$('.content__link.' + blockId /* , container */);
    const innerPanels = $$('.content__detail.' + blockId /* , container */);

    innerTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const id = tab.getAttribute('data-tab-' + blockId);
        const target = id ? document.getElementById(id) : null;
        activeTab(tab, target, innerTabs, innerPanels);
      });
    });

    // 初期アクティブ（1個目）※サブタブ
    setInitialActive(innerTabs, innerPanels);
  });
});
